var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('notifications'),('supplier' === _vm.getUserRole(_vm.sesion))?_c('SupplierProfile',{attrs:{"userId":_vm.getUserId(_vm.sesion)}}):_c('ManagerProfile',{attrs:{"userId":_vm.getUserId(_vm.sesion)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }